// initial state
const state = () => ({
    loadings: {
        showLoadingTemplate: {
            show: '',
            size: '120px',
            margin: '-60px 0 0 -60px' // Margin sempre é a metade do size
        },
        showLoadingHeader: {
            show: '',
            size: '50px',
            margin: '-25px 0 0 -25px'
        },
        showLoadingSidebar: {
            show: '',
            size: '64px',
            margin: '-32px 0 0 -32px'
        },
        showLoadingMain: {
            show: '',
            size: '90px',
            margin: '-45px 0 0 -45px'
        },
        showLoadingFooter: {
            show: '',
            size: '30px',
            margin: '-15px 0 0 -15px'
        },
        loadingBtn: {
            show: false,
            text: '',
            date: null,
        }
    }
})

// getters
const getters = {
    getLoadingState(state) {
        return state;
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setLoadingState(state, payload)
    {
        for (var [key, value] of Object.entries(payload)) {
            state[key] = value;
        }
    },

    setLoadingBtnStatusState(state, payload)
    {
        state.loadings.loadingBtn.show = payload;
    },
    setLoadingBtnTextState(state, payload)
    {
        state.loadings.loadingBtn.text = payload;
    },
    setLoadingBtnDateState(state, payload)
    {
        state.loadings.loadingBtn.date = payload;
    },

    setStateLoadingSideBar(state, payload) {
        state.loadings.showLoadingSidebar.show = payload;
    },

    setStateLoadingTemplate(state, payload) {
        state.loadings.showLoadingTemplate.show = payload;
    },

    setStateLoadingHeader(state, payload) {
        state.loadings.showLoadingHeader.show = payload;
    },

    setStateLoadingMain(state, payload) {
        state.loadings.showLoadingMain.show = payload;
    },

    setStateLoadingFooter(state, payload) {
        state.loadings.showLoadingFooter.show = payload;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
